/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Operator
 */
export interface Operator {
    /**
     * 
     * @type {string}
     * @memberof Operator
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof Operator
     */
    id: string;
    /**
     * Whether or not this operator needs input
     * @type {boolean}
     * @memberof Operator
     */
    requireInput: boolean;
}

/**
 * Check if a given object implements the Operator interface.
 */
export function instanceOfOperator(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "label" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "requireInput" in value;

    return isInstance;
}

export function OperatorFromJSON(json: any): Operator {
    return OperatorFromJSONTyped(json, false);
}

export function OperatorFromJSONTyped(json: any, ignoreDiscriminator: boolean): Operator {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'label': json['label'],
        'id': json['id'],
        'requireInput': json['requireInput'],
    };
}

export function OperatorToJSON(value?: Operator | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'label': value.label,
        'id': value.id,
        'requireInput': value.requireInput,
    };
}

